import { configWithWebToken } from "./config";
import { IRestaurant } from "../models/IRestaurant";

export const getRestaurantById = (restaurantId: string) =>
  configWithWebToken.get<IRestaurant>("Restourants/" + restaurantId);
